<svelte:options customElement="hb-layout-mobile" />

<script lang="ts">
  /**
   * Svelte Video Gallery WebComponent
   * =====================
   *
   * @contributors: Dario Caruso <dev@dariocaruso.info> (https://dariocaruso.info)
   *
   * @license: MIT License
   *
   */

  import pkg from "../../../package.json";

  import type { Events as OffcanvasEvents } from "../offcanvas/types/webcomponent.type";
  import type { Events as NavbarEvents } from "../navbar/types/webcomponent.type";
  import type { Events as FooterEvents } from "../footer/types/webcomponent.type";

  import type { Component } from "./types/webcomponent.type";
  import parseStyle from "style-to-object";

  import { styleSetup as offcanvasStyleSetup } from "../offcanvas/extra/docs";
  import { styleSetup as footerStyleSetup } from "../footer/extra/docs";
  import { styleSetup as navbarStyleSetup } from "../navbar/extra/docs";
  import { styleSetup as cookieLawBannerStyleSetup } from "../cookie-law-banner/extra/docs";
  import { styleSetup as sidebarDesktopStyleSetup } from "../sidebar-desktop/extra/docs";

  import {
    addComponent,
    getChildStyleToPass,
    LanguageTranslator,
  } from "wc-js-utils";

  let {
    id = "",
    // style = "",
    footer = { type: "auto", disable_expanding_small: false },
    cookielawuri4more = "",
    cookielawallowdecline = false,
    cookielawlanguage = "",
    pagename = undefined,
    cookielaw = undefined,
    onescreen = undefined,
    sidebar = {},
    socials = undefined,
    navlinks = undefined,
    contacts = undefined,
    columns = undefined,
    usermenu = undefined,
    i18nlang = undefined,
    page_title = undefined,
    policies = undefined,
    company = undefined,
  }: Component = $props();

  // let translator: LanguageTranslator;

  let parsedStyle: { [x: string]: string } = $state({});

  let offcanvasStyleToSet: string = $state("");
  let footerStyleToSet: string = $state("");
  let navbarStyleToSet: string = $state("");
  let cookieLawBannerStyleToSet: string = $state("");
  let sidebarDesktopStyleToSet: string = $state("");

  let navopen: boolean = $state(false);
  let screensize = $state("");

  $effect(() => {
    // if (style) {
    //   parsedStyle = parseStyle(style) as any;
    //   offcanvasStyleToSet = getChildStyleToPass(
    //     parsedStyle,
    //     offcanvasStyleSetup?.vars
    //   );
    //   footerStyleToSet = getChildStyleToPass(
    //     parsedStyle,
    //     footerStyleSetup?.vars
    //   );
    //   navbarStyleToSet = getChildStyleToPass(
    //     parsedStyle,
    //     navbarStyleSetup?.vars
    //   );
    //   cookieLawBannerStyleToSet = getChildStyleToPass(
    //     parsedStyle,
    //     cookieLawBannerStyleSetup?.vars
    //   );
    //   sidebarDesktopStyleToSet =
    //     sidebarDesktopStyleToSet +
    //     getChildStyleToPass(parsedStyle, sidebarDesktopStyleSetup?.vars);
    // }

    if (typeof footer === "string") footer = JSON.parse(footer);
    if (!footer.type) footer.type = "auto";

    if (typeof onescreen === "string") {
      if (onescreen !== "no") onescreen = true;
      else onescreen = false;
    } else if (!onescreen) {
      onescreen = false;
    }

    if (typeof sidebar === "string") {
      sidebar = JSON.parse(sidebar);
    }
    if (typeof company === "string") {
      company = JSON.parse(company as unknown as string);
    }

    screensize = onescreen
      ? "display: flex;flex-direction: column;	height: 100vh;"
      : "display:block;";

    // 		if (!translator) {
    // 	translator = new LanguageTranslator({ dictionary, lang: i18nlang });
    // } else if (translator && i18nlang && translator.lang && translator.lang !== i18nlang) {
    // 	translator = new LanguageTranslator({ dictionary, lang: i18nlang });
    // }
  });

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }

  addComponent({ repoName: "@htmlbricks/hb-footer", version: pkg.version });
  addComponent({ repoName: "@htmlbricks/hb-offcanvas", version: pkg.version });
  addComponent({ repoName: "@htmlbricks/hb-navbar", version: pkg.version });
  addComponent({
    repoName: "@htmlbricks/hb-cookie-law-banner",
    version: pkg.version,
  });
  addComponent({
    repoName: "@htmlbricks/hb-sidebar-desktop",
    version: pkg.version,
  });

  function openmenu(o: OffcanvasEvents["offcanvasswitch"]) {
    console.log("burgerclick", o);
    navopen = o.isOpen;

    dispatch("offcanvasswitch", o);
  }
</script>

{#if navlinks?.length}
  <hb-offcanvas
    style={offcanvasStyleToSet}
    navpage={pagename || ""}
    navlinks={navlinks || "[]"}
    companytitle={sidebar?.title}
    companylogouri={sidebar?.logo}
    onoffcanvasswitch={(el: { detail: OffcanvasEvents["offcanvasswitch"] }) =>
      openmenu(el.detail)}
    opened={navopen ? "yes" : "no"}
    type="autohide"
    onpageChange={(p: { detail: OffcanvasEvents["pageChange"] }) =>
      dispatch("pageChange", p.detail)}
  >
    <span slot="header"><slot name="nav-header-slot" /></span>
  </hb-offcanvas>
{/if}
<div style={screensize} part="container">
  <hb-navbar
    part="navbar"
    style={navbarStyleToSet}
    noburger={navlinks ? "" : "yes"}
    companylogouri={company?.logoUri || ""}
    companybrandname={page_title || company?.siteName || ""}
    usermenu={usermenu || ""}
    switchopen={navopen ? "yes" : "no"}
    onnavmenuswitch={(el: { detail: NavbarEvents["navmenuswitch"] }) =>
      openmenu(el.detail)}
    onnavbarDropDownClick={(el: {
      detail: NavbarEvents["navbarDropDownClick"];
    }) => dispatch("navbarDropDownClick", el.detail)}
    onnavbarSlotClick={(l: { detail: NavbarEvents["navbarSlotClick"] }) =>
      dispatch("navbarSlotClick", l.detail)}
  >
    <span slot="left-slot"><slot name="nav-left-slot" /></span>
    <span slot="center-slot"><slot name="nav-center-slot" /></span>
    <span slot="right-slot"><slot name="nav-right-slot" /></span>
  </hb-navbar>

  <div style={onescreen ? "flex: 2" : ""} part="page" id="page">
    <slot name="page">page</slot>
  </div>
  {#if cookielaw || cookielawallowdecline || cookielawlanguage || cookielawuri4more}
    <hb-cookie-law-banner
      style={cookieLawBannerStyleToSet}
      language={cookielawlanguage || i18nlang}
      allowdecline={cookielawallowdecline}
      {cookielawuri4more}
    ></hb-cookie-law-banner>
  {/if}
  <hb-footer
    {policies}
    type={footer.type === "auto"
      ? onescreen
        ? "small"
        : "regular"
      : footer.type}
    part="footer"
    socials={socials ? JSON.stringify(socials) : ""}
    contacts={contacts ? JSON.stringify(contacts) : ""}
    style="display:block;{footerStyleToSet}"
    company={company ? JSON.stringify(company) : ""}
    columns={columns || ""}
    disable_expanding_small={footer.disable_expanding_small ? "yes" : "no"}
    onfooterClick={(el: { detail: FooterEvents["footerClick"] }) =>
      dispatch("footerClick", el.detail)}
  ></hb-footer>
</div>

<style lang="scss">
  // @forward "./styles/bootstrap.scss";
  @forward "./styles/webcomponent.scss";
  hb-sidebar-desktop {
    position: absolute;
    width: 240px;
    height: 100%;
    min-height: 100vh;
  }
</style>
